import Actions from "./RapportiControlloActions";
import { RapportoControlloLite } from "../generated";
import Dispatcher from "../common/dispatcher";
import { AbstractLookupStore } from "../common/AbstractStores";


class RapportiControlloStore extends AbstractLookupStore<RapportoControlloLite>{
    constructor() {
        super();
        Dispatcher
            .onfunction(Actions.getByIdImpianto, result => this.set(result.idImpianto.toString(), result.rapportiControllo))
            .onfunction(Actions.create, result => {
                this.addOne(result.idImpianto.toString(), result, x => x.idImpianto.toString());
            })
            .onfunction(Actions.delete, data => {
                if (data.result)
                    this.deleteOne(data.idImpianto.toString(), this.getKey(data.year, data.number), x => this.getKey(x.year, x.number))
            })
    }


    private getKey(year: number, number: number) {
        return `${year}/${number}`
    }
    public useForImpianto = (idImpianto: number) => this.useStoreWithAction(idImpianto.toString(), key => Actions.getByIdImpianto(+key));
    public use = (idImpianto: number, id: string) => this.useForImpianto(idImpianto)?.find(i => i.nrRapporto == id);

}

export default new RapportiControlloStore()
